import {Component, OnInit,ViewChild} from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MatDialog,
  MatTableDataSource,
  PageEvent,
  MatDatepickerInputEvent,
  MatPaginator,
} from "@angular/material";
import * as moment from "moment";
import { AppService } from "src/_services/app.service";
import { Router } from "@angular/router";
import { SapRoles } from "src/_constants/roleType";
import { AuthenticationService } from "src/_services/authentication.service";
@Component({
  selector: 'app-game-analysis',
  templateUrl: './game-analysis.component.html',
  styleUrls: ['./game-analysis.component.scss']
})
export class GameAnalysisComponent implements OnInit {

  accountColumns: string[] = [
    "Operator",
    "Active Users",
    "Total Bets",
    "Won",
    "Lost",
    "Void",
    "Open",
    "PL",
  ];

  marketColumns: string[] = [
    "Market",
    "Bets",
    "Won",
    "Lost",
    "Void",
    "Open",
    "PL",
    "Result",
  ];

  sportsBook = [
    { id: "Cricket", name: "Cricket" },
    { id: "Soccer", name: "Soccer" },
    { id: "Tennis", name: "Tennis" },
    { id: "MMA", name: "MMA" },
    { id: "Baseball", name: "Baseball" },
    { id: "Basketball", name: "Basketball" },
    { id: "Kabaddi", name: "Kabaddi" },
    { id: "Table Tennis", name: "Table Tennis" },
    { id: "Badminton", name: "Badminton" },
    { id: "Ice Hockey", name: "Ice Hockey" },
  ];

  exchangeSports = [
    { id: "Cricket", name: "Cricket" },
    { id: "Soccer", name: "Soccer" },
    { id: "Tennis", name: "Tennis" },
    { id: "Mixed Martial Arts", name: "Mixed Martial Arts" },
    { id: "BaseBall", name: "BaseBall" },
    { id: "BasketBall", name: "BasketBall" },
    { id: "Boxing", name: "Boxing" },
    { id: "Volleyball", name: "Volleyball" },
    { id: "Kabaddi", name: "Kabaddi" },
    { id: "Snooker", name: "Snooker" },
    { id: "American Football", name: "American Football" },
    { id: "Horse Racing", name: "Horse Racing" },
    { id: "Greyhound Racing", name: "Greyhound Racing" },
  ];

  marketType = [
    "All","FANCY","MATCH_ODDS","BOOKMAKER","LINE_ODDS"
  ]

  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  today = new Date();
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  formDate = new FormControl(this.today);
  toDate = new FormControl(new Date(this.today.getTime() + 86400000));
  totalRecords: number;
  sapRoles = SapRoles;
  selectedSport = new FormControl([]);
  selectedEvent = new FormControl([]);
  ProviderId = new FormControl([]);
  report = "account";
  events = [];
  sports = [];
  accounts = new MatTableDataSource<any>();
  markets = new MatTableDataSource<any>();
  sportSettings: any = {};
  eventSettings: any = {};
  dropdownSettings: any = {};
  accsummary;
  marsummary;

  showAlert: any = false;

  selected: any = {
    startDate: moment().subtract(6, "days"),
    endDate: moment(),
  };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  providers: any = JSON.parse(sessionStorage.getItem("category"));
  length: any = 0;

  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getAdminProviders()
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.sportSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.eventSettings = {
      singleSelection: true,
      idField: "event_id",
      textField: "customText",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    //this.getBetList();
  }

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    //this.paginator.pageIndex = 0;
    //this.page = 1;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 7) {
        this.showAlert = true;
        this.selected.startDate = moment().subtract(6, "days"),
        this.selected.endDate = moment();
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);
      } else if (this.selected.startDate !== null) {
        this.onChangeSports();
      }
    }
  };

  getAdminProviders() {
    if (
      this.userRole.role === this.sapRoles.SAPAdmin ||
      this.userRole.role === this.sapRoles.SAPUser
    ) {
      this.providers = ["Exchange", "SportsBook"];
    }
    this.onSelectedProvider(this.providers[0]);
  }

  onSelectedProvider = (pid) => {
    if (pid == "Exchange") {
      this.sports = this.exchangeSports
    } else {
      this.sports = this.sportsBook
    }
    this.ProviderId.setValue([pid]);
    this.selectedEvent.setValue([]);
    this.events = [];
    this.selectedSport.setValue([]);
  };

  onSelectedStatusChange(value) {
    if (this.selectedEvent.value !== "") {
      if (value === "ACCOUNT LEVEL"){
        this.report = "account"
      } else {
        this.report = "market"
      }
      this.getGameAnalysis();
      this.getGameAnalysisSummary();
    }
  }

  onChangeSports() {
    this.selectedEvent.setValue([]);
    this.page = 1;
    this.getEvents();
  }

  onDeselectSports() {
    this.events = [];
    this.selectedEvent.setValue([]);
    this.page = 1;
  }

  onChangeEvent() {
    this.getGameAnalysis();
    this.getGameAnalysisSummary();
  }


  getEvents() {
    let filters = {
      sportId: this.selectedSport.value[0].id,
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
    };

    this.appService.getGameAnalysisEvents(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.events = res.events;
        this.events.forEach(event => {
          event.customText = `${this.getEventDate(event.open_date)} ${event.event_name}`;
        });
      }
    });
  }

  getEventDate = (date: number) => {
    return moment(date).format("DD-MM-YYYY");
  };

  getGameAnalysis() {
    let filters = {
      sportId: this.selectedSport.value[0].id,
      report: this.report,
      eventId: this.selectedEvent.value[0].event_id,
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
      PageSize: this.orgPageSize,
      Page: this.page,
    };
    console.log(filters)
    this.appService.getGameAnalysis(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.accounts = new MatTableDataSource<any>(res.accountAnalysis);
        this.markets = new MatTableDataSource<any>(res.marketAnalysis);
        if (this.page == 1) {
          this.length = res.totalBets;
        } else {
          this.paginator.length = this.length;
        }
      }
    });
  }

  getGameAnalysisSummary() {
    let filters = {
      sportId: this.selectedSport.value[0].id,
      report: this.report,
      eventId: this.selectedEvent.value[0].event_id,
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
    };
    console.log(filters)
    this.appService.getGameAnalysisSummary(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.accsummary = res.accountRecord;
        this.marsummary = res.marketRecord;
        console.log(this.accsummary)
      }
    });
  }

 



  


}
